import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  showAll() {
    const rows = this.element.querySelectorAll('[data-task-row]');
    for (var i = 0; i < rows.length; i++) {
      rows[i].classList.remove('hidden');
    }
    this.element.querySelector('[data-show-all-link]').classList.add('hidden');
    const allTasksDoneElement = this.element.querySelector('[data-all-tasks-done]');
    if (allTasksDoneElement) {
      allTasksDoneElement.classList.add('hidden');
    }
  }
}